import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import vegBadge from "../../media/images/veg-badge.webp";
import nonVegBadge from "../../media/images/non-veg-badge.webp";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { deleteCart, editQtyCart } from "../../redux/actions/checkout";

export default function ItemCard(props) {
  const { id, img, name, price, qty } = props;

  const dispatch = useDispatch();
  const { activeOutlet } = useSelector((state) => state.config);

  function onClickSub() {
    dispatch(editQtyCart({ id, qty: qty - 1 }));
    if (qty === 1) {
      dispatch(deleteCart(id));
    }
  }

  function onClickPlus() {
    dispatch(editQtyCart({ id, qty: qty + 1 }));
  }

  return (
    <div className="item-card">
      <div className="img">
        <img src={img} alt={name} />
      </div>

      <div className="content">
        <div className="name">
          <p>{name}</p>
        </div>
        <div className="details">
          <div className="price">
            <h3>
              {activeOutlet.outletCurrency} {price.toFixed(2)}
            </h3>
          </div>

          {/* <div className="best-seller">BESTSELLER</div> */}

          {/* <div className="badge">
                  {item.type === "veg" && <img src={vegBadge} alt="veg badge" />}
                  {item.type === "nonveg" && <img src={nonVegBadge} alt="non-veg badge" />}
                </div> */}
        </div>

        <div className="actions">
          <p className="qty-text">Qty :</p>

          <div className="btn-selected">
            <div className="sub" onClick={() => onClickSub()}>
              <RemoveIcon style={{ fontSize: 15 }} />
            </div>
            <div className="num">{qty}</div>
            <div className="add" onClick={() => onClickPlus()}>
              <AddIcon style={{ fontSize: 15 }} />
            </div>
          </div>
        </div>
      </div>

      <div className="cross" onClick={() => dispatch(deleteCart(id))}>
        <CloseIcon />
      </div>
    </div>
  );
}
